/** Localize widget UI and display attributed review translations with accessible originals. */
(() => {
  'use strict';
  if (window.monoreeWidgetLocalizationInstalled) return;
  window.monoreeWidgetLocalizationInstalled = true;
  const locale = document.documentElement.lang.toLowerCase().split('-')[0];
  let paymentLabel = '';
  let walletLabel = '';
  if (locale === 'lv' || locale === 'et') {
    try {
      const copy = JSON.parse(document.getElementById('MonoreeAppCopy')?.textContent || '{}');
      paymentLabel = typeof copy.more_payment_options === 'string' ? copy.more_payment_options : '';
      walletLabel = typeof copy.wallet_button_label === 'string' ? copy.wallet_button_label : '';
    } catch (_) {}
  }
  const walletParts = walletLabel.split('[wallet]');
  const hasWalletLabel = walletParts.length === 2 && walletParts[0].trim().length > 0;
  const labels = {
    lt: {
      notifyTitle: 'Pranešime, kai prekė vėl bus prekyboje.', email: 'El. pašto adresas', notify: 'Pranešti man',
      reviews: 'Klientų atsiliepimai', other: 'Atsiliepimai kitomis kalbomis', count: 'Atsiliepimų skaičius',
      sort: ['Naujausi', 'Aukščiausias įvertinimas', 'Žemiausias įvertinimas', 'Tik su nuotraukomis', 'Pirmiausia su nuotraukomis', 'Pirmiausia su vaizdo įrašais', 'Naudingiausi']
    },
    lv: {
      notifyTitle: 'Paziņosim, kad prece atkal būs pieejama.', email: 'E-pasta adrese', notify: 'Paziņot man',
      reviews: 'Klientu atsauksmes', other: 'Atsauksmes citās valodās', count: 'Atsauksmju skaits',
      sort: ['Jaunākās', 'Augstākais vērtējums', 'Zemākais vērtējums', 'Tikai ar fotoattēliem', 'Vispirms ar fotoattēliem', 'Vispirms ar video', 'Noderīgākās']
    },
    et: {
      notifyTitle: 'Anname teada, kui toode on jälle saadaval.', email: 'E-posti aadress', notify: 'Teavita mind',
      reviews: 'Klientide arvustused', other: 'Arvustused teistes keeltes', count: 'Arvustusi',
      sort: ['Uusimad', 'Kõrgeim hinnang', 'Madalaim hinnang', 'Ainult fotodega', 'Fotodega esimesena', 'Videotega esimesena', 'Kõige kasulikumad']
    },
    pl: {
      notifyTitle: 'Powiadomimy Cię, gdy produkt będzie ponownie dostępny.', email: 'Adres e-mail', notify: 'Powiadom mnie',
      reviews: 'Opinie klientów', other: 'Opinie w innych językach', count: 'Liczba opinii',
      sort: ['Najnowsze', 'Najwyższa ocena', 'Najniższa ocena', 'Tylko ze zdjęciami', 'Najpierw ze zdjęciami', 'Najpierw z filmami', 'Najbardziej pomocne']
    }
  }[locale];
  if (!labels) return;
  const rootSelector = '.restock-alerts-modal-wrapper, .restock-alerts-form-body, .jdgm-widget, .jdgm-carousel-wrapper, .jm-review-widget' +
    (paymentLabel || hasWalletLabel ? ', .shopify-payment-button' : '');
  const sortKeys = ['created_at', 'highest_rating', 'lowest_rating', 'with_pictures', 'pictures_first', 'videos_first', 'most_helpful'];
  const queued = new Set();
  let frame = 0;

  // Reviewed translations are keyed to the exact published customer text.
  // Unknown/new reviews retain the app's language handling and customer wording.
  const reviewCopy = {
    lv: { translated: 'Tulkojums no lietuviešu valodas', original: 'Skatīt oriģinālu', translation: 'Skatīt tulkojumu', untranslated: 'Atsauksme oriģinālvalodā', rating: 'Vērtējums: [score] no 5' },
    et: { translated: 'Tõlge leedu keelest', original: 'Vaadake originaali', translation: 'Vaadake tõlget', untranslated: 'Arvustus algkeeles', rating: 'Hinnang: [score] / 5' },
    pl: { translated: 'Tłumaczenie z języka litewskiego', original: 'Zobacz oryginał', translation: 'Zobacz tłumaczenie', untranslated: 'Opinia w języku oryginalnym', rating: 'Ocena: [score] na 5' },
    lt: { rating: 'Įvertinimas: [score] iš 5' }
  }[locale];
  const reviewed = [
    ['Nuostabus labai gražus žiedas, įpakavimas 10/10 rekomenduoju!', 'Brīnišķīgs, ļoti skaists gredzens, iepakojums 10/10. Iesaku!', 'Imeline, väga ilus sõrmus, pakend 10/10. Soovitan!', 'Cudowny, bardzo piękny pierścionek, opakowanie 10/10. Polecam!'],
    ['Nuostabiai blizga.', 'Brīnišķīgi mirdz.', 'Särab imeliselt.', 'Cudownie błyszczy.'],
    ['Labai patiko. gražus žiedas, greitas pristatymas', 'Ļoti patika. Skaists gredzens, ātra piegāde.', 'Meeldis väga. Ilus sõrmus, kiire tarne.', 'Bardzo mi się spodobał. Piękny pierścionek, szybka dostawa.'],
    ['Labai gražūs, geras užsegimas, atrodo puošniai', 'Ļoti skaisti, laba aizdare, izskatās grezni.', 'Väga ilusad, hea kinnitus, näevad pidulikud välja.', 'Bardzo piękne, dobre zapięcie, wyglądają elegancko.'],
    ['Labai gražus, blizga nerealiai, bet kiekvienai dienai ne labai, aštrokas, trumpam pasipuošti viskas normaliai', 'Ļoti skaists, neticami mirdz, bet ikdienai ne pārāk piemērots — nedaudz ass. Uz īsu brīdi saposties ir labi.', 'Väga ilus, särab uskumatult, aga igapäevaseks kandmiseks eriti ei sobi — veidi terav. Lühiajaliselt pidulikuks kandmiseks on täiesti sobiv.', 'Bardzo piękny, niesamowicie błyszczy, ale na co dzień niezbyt się nadaje — jest trochę ostry. Żeby założyć go na krótko, wszystko jest w porządku.'],
    ['Puikus papuošalas, nuostabi dovana dukrai!', 'Lieliska rota, brīnišķīga dāvana meitai!', 'Suurepärane ehe, imeline kingitus tütrele!', 'Wspaniała biżuteria, cudowny prezent dla córki!'],
    ['Puikus žiedas', 'Lielisks gredzens.', 'Suurepärane sõrmus.', 'Świetny pierścionek.'],
    ['Labai gražūs auskarai, gražioje dėžutėje 🙂', 'Ļoti skaisti auskari skaistā kastītē 🙂', 'Väga ilusad kõrvarõngad ilusas karbis 🙂', 'Bardzo piękne kolczyki w ładnym pudełku 🙂'],
    ['Labai gražūs papuošalai,labai gražiai supakuota, su maišeliais! Labai patenkinta! Rekomenduosiu draugėms būtinai!!!', 'Ļoti skaistas rotaslietas, ļoti skaisti iesaiņotas, ar maisiņiem! Esmu ļoti apmierināta! Noteikti ieteikšu draudzenēm!!!', 'Väga ilusad ehted, väga kaunilt pakitud, koos kotikestega! Olen väga rahul! Soovitan kindlasti sõbrannadele!!!', 'Bardzo piękna biżuteria, bardzo ładnie zapakowana, z woreczkami! Jestem bardzo zadowolona! Na pewno polecę koleżankom!!!'],
    ['Nuostabus', 'Brīnišķīgs.', 'Imeline.', 'Wspaniały.'],
    ['super', 'Super!', 'Super!', 'Super!'],
    ['Labai patiko, kad yra užsukamas užsegimas🌞', 'Ļoti patika, ka ir skrūvējama aizdare 🌞', 'Mulle meeldis väga, et kinnitus on keeratav 🌞', 'Bardzo mi się spodobało zakręcane zapięcie 🌞'],
    ['Esu labai patenkinta, žiedą nešioju kiekvieną dieną :)', 'Esmu ļoti apmierināta, gredzenu nēsāju katru dienu :)', 'Olen väga rahul, kannan sõrmust iga päev :)', 'Jestem bardzo zadowolona, noszę pierścionek codziennie :)'],
    ['Labai gražus, subtilus žiedas', 'Ļoti skaists, smalks gredzens.', 'Väga ilus, õrn sõrmus.', 'Bardzo piękny, subtelny pierścionek.'],
    ['Labai puošnus ir kokybiškas žiedas. Esu patenkinta!', 'Ļoti grezns un kvalitatīvs gredzens. Esmu apmierināta!', 'Väga pidulik ja kvaliteetne sõrmus. Olen rahul!', 'Bardzo elegancki i wysokiej jakości pierścionek. Jestem zadowolona!'],
    ['Puiku! :)', 'Lieliski! :)', 'Suurepärane! :)', 'Świetnie! :)'],
    ['Greita, gražu, tvarkinga', 'Ātri, skaisti, kārtīgi.', 'Kiire, ilus, korralik.', 'Szybko, pięknie, starannie.'],
    ['Puikūs!', 'Lieliski!', 'Suurepärased!', 'Wspaniałe!'],
    ['Puikus, elegantiškas 👌', 'Lielisks, elegants 👌', 'Suurepärane, elegantne 👌', 'Wspaniały, elegancki 👌'],
    ['Gražus', 'Skaists.', 'Ilus.', 'Piękny.']
  ];
  const reviewIds = ['91b6216a-23ef-4138-9cdd-44f217615351','b8f07276-a1a8-44e8-9e66-4058fecdd665','2a0a1cc8-c6e6-40a7-9f0f-f8e09f43ed4f','af65af8b-af58-4f17-b07f-2c00b96848c4','a8ecc8a5-4b65-4a72-a6e2-97eb7f48c37c','9e1cf272-407a-4b8c-9569-c347765148a8','6b240fb2-fe69-41ab-8755-306bbaabd507','9e873d14-507c-4044-a1a9-86a4b2e09c79','fed9b8e9-8534-4f05-a4f8-5e34f2a89d37','a1ef1453-8837-45af-8f0e-dbc0b95c3a62','da7897ee-138d-495b-93c8-d005246344d4','a1d9398e-64d1-4086-93ea-0acea9b59fa8','8decc365-3c64-4b93-82b2-1f0989006302','394d1120-09c0-4c2b-bd76-455f9350908a','5134c017-d0a0-48a4-8b89-48db45a97f61','5688d5e4-6a7e-4905-8aa4-a9ff8e258916','48426119-d9b6-425f-a8b8-172586c5544a','52d58ee3-a4f8-4554-8192-8c57dc8a11c1','77d44af5-5ba5-41aa-9d30-81fd7fb88dd5','083e1b0a-c3b2-4e04-ba2e-001b66817041'];
  const normalized = (value) => value.replace(/\s+/g, ' ').trim();
  const comparable = (value) => normalized(value).replace(/[.!]+$/, '');
  const nativeCopies = {
    10: ['suurepärane', 'świetnie', 'lieliski'],
    11: ['Mulle meeldis väga, et sellel on keeratav kinnitus🌞'],
    14: ['Väga elegantne ja kvaliteetne sõrmus. Olen rahul!']
  };
  const translationIndex = { lv: 1, et: 2, pl: 3 }[locale];
  const translationMap = new Map(reviewed.map((entry) => [normalized(entry[0]), entry[translationIndex]]));
  const translatedNodes = new WeakMap();

  function localizeReviewUI(root) {
    root.querySelectorAll('[aria-label], [title]').forEach((node) => {
      for (const name of ['aria-label', 'title']) {
        const match = node.getAttribute(name)?.match(/^([\d.,]+)(?: out of 5)? stars?$/i);
        if (match) {
          const score = new Intl.NumberFormat(locale).format(Number(match[1].replace(',', '.')));
          node.setAttribute(name, reviewCopy.rating.replace('[score]', score));
        }
      }
    });
    root.querySelectorAll('.jdgm-carousel-item__timestamp, .jdgm-rev__timestamp, .jm-review-date, .jm-reviewer-info__date').forEach((node) => {
      const raw = node.getAttribute('data-time') || node.getAttribute('datetime') || node.textContent.trim();
      const us = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
      const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/);
      if (!us && !iso) return;
      const year = us ? us[3] : iso[1];
      const month = (us ? us[1] : iso[2]).padStart(2, '0');
      const day = (us ? us[2] : iso[3]).padStart(2, '0');
      const date = new Date(`${year}-${month}-${day}T12:00:00Z`);
      if (!Number.isFinite(date.getTime()) || date.getUTCMonth() + 1 !== Number(month) || date.getUTCDate() !== Number(day)) return;
      text(node, locale === 'lt' ? `${year}-${month}-${day}` : `${day}.${month}.${year}${locale === 'lv' ? '.' : ''}`);
    });
    if (!translationIndex) return;
    root.querySelectorAll('.jdgm-carousel-item__review-body').forEach((body) => {
      const content = body.closest('.jdgm-carousel-item__review-content');
      if (!content) return;
      const existing = translatedNodes.get(body);
      const current = body.textContent.trim();
      if (existing && content.contains(existing.notice) &&
          normalized(existing.translation) === normalized(current)) return;
      if (existing && ![existing.original, existing.translation].some((value) => normalized(value) === normalized(current))) delete body.dataset.monoreeReviewOriginal;
      // Carousel copies may include markup but not event listeners. Rebind them once.
      content.querySelectorAll('.monoree-review-language').forEach((notice) => notice.remove());
      const knownIndex = reviewIds.indexOf(body.closest('.jdgm-carousel-item')?.dataset.reviewId);
      const known = reviewed[knownIndex];
      const verifiedCopy = known && [...known, ...(nativeCopies[knownIndex] || [])].some((value) => comparable(value) === comparable(current));
      const original = body.dataset.monoreeReviewOriginal || (verifiedCopy && normalized(current) !== normalized(known[0]) ? known[0] : current);
      const translation = translationMap.get(normalized(original));
      if (!translation) return;
      const notice = document.createElement('div');
      notice.className = 'monoree-review-language';
      notice.style.cssText = 'font:inherit;font-size:11px;line-height:1.4;margin-top:8px;white-space:normal;';
      const caption = document.createElement('span');
      caption.textContent = translation ? reviewCopy.translated + ' · ' : reviewCopy.untranslated;
      notice.appendChild(caption);
      if (translation) {
        // Customer wording is retained separately from the displayed translation.
        body.dataset.monoreeReviewOriginal = original;
        const translated = document.createElement('p');
        translated.textContent = translation;
        translated.lang = locale;
        body.replaceChildren(translated);
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.setAttribute('data-monoree-review-toggle', '');
        toggle.textContent = reviewCopy.original;
        toggle.style.cssText = 'font:inherit;color:inherit;text-decoration:underline;border:0;background:none;padding:0;cursor:pointer;';
        notice.appendChild(toggle);
        body.lang = locale;
      }
      content.appendChild(notice);
      translatedNodes.set(body, { notice, original, translation });
    });
  }
  // Delegation also works when the carousel clones/rebuilds its card markup.
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest?.('button[data-monoree-review-toggle]');
    if (!toggle) return;
    const body = toggle.closest('.jdgm-carousel-item__review-content')?.querySelector('.jdgm-carousel-item__review-body');
    const original = body?.dataset.monoreeReviewOriginal;
    const translation = original && translationMap.get(normalized(original));
    if (!original || !translation) return;
    event.preventDefault();
    event.stopPropagation();
    const reviewKey = body.closest('.jdgm-carousel-item')?.dataset.reviewId || normalized(original);
    const oldDialog = document.getElementById('MonoreeReviewOriginal');
    if (oldDialog) oldDialog.remove();
    const dialog = document.createElement('dialog');
    dialog.id = 'MonoreeReviewOriginal';
    dialog.setAttribute('aria-labelledby', 'MonoreeReviewOriginalTitle');
    dialog.style.cssText = 'width:min(90vw,34rem);max-height:80vh;overflow:auto;border:1px solid #ddd;border-radius:10px;padding:24px;background:#fff;color:#222;font:inherit;text-align:left;box-shadow:0 8px 40px #0003;';
    const heading = document.createElement('h2');
    heading.id = 'MonoreeReviewOriginalTitle';
    heading.style.cssText = 'font:inherit;font-size:1.2em;margin:0 0 16px;';
    heading.textContent = {lv:'Atsauksmes oriģināls',et:'Arvustuse originaal',pl:'Oryginalna opinia'}[locale];
    const paragraph = document.createElement('p');
    paragraph.lang = 'lt';
    paragraph.style.cssText = 'white-space:pre-wrap;line-height:1.6;';
    paragraph.textContent = original;
    const close = document.createElement('button');
    close.type = 'button';
    close.textContent = {lv:'Aizvērt',et:'Sulge',pl:'Zamknij'}[locale];
    close.style.cssText = 'font:inherit;padding:8px 18px;border:1px solid #333;background:#fff;color:#222;cursor:pointer;margin-top:10px;';
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { dialog.remove(); if (toggle.isConnected) toggle.focus({preventScroll:true}); });
    dialog.append(heading, paragraph, close);
    document.body.appendChild(dialog);
    dialog.showModal();
  }, true);

  function text(node, value) {
    // Preserve the text node owned by React/Vue; replacing it breaks their references.
    if (!node || node.children.length !== 0) return;
    const parts = [...node.childNodes].filter((child) => child.nodeType === 3 && child.data.trim());
    if (parts.length === 1 && parts[0].data !== value) parts[0].data = value;
  }
  function decimal(value) {
    return value.replace(/(\d)\.(?=\d)/g, '$1,');
  }
  function localizeWallet(component) {
    try {
      const button = component.button;
      if (!(button instanceof HTMLButtonElement) || button.getRootNode().host !== component || button.type !== 'button') return;
      const apple = component.localName === 'shopify-apple-pay-button';
      const content = button.querySelector(apple ? '.apple-pay--content' : '.content');
      if (!content || content.parentElement !== button) return;
      const [prefix, logo, suffix] = content.children;
      if (content.children.length < 2 || content.children.length > 3 || prefix?.tagName !== 'SPAN' || logo?.localName !== 'svg') return;
      if (prefix.childNodes.length !== 1 || prefix.firstChild.nodeType !== Node.TEXT_NODE) return;
      if (prefix.textContent !== 'Pirkti naudojant ' && prefix.textContent !== walletParts[0]) return;
      if (suffix && (suffix.tagName !== 'SPAN' || !suffix.hasAttribute('data-monoree-wallet-suffix') || suffix.childNodes.length !== 1 || suffix.firstChild.nodeType !== Node.TEXT_NODE)) return;
      if (prefix.firstChild.data !== walletParts[0]) prefix.firstChild.data = walletParts[0];
      if (walletParts[1] && !suffix) {
        const tail = document.createElement('span');
        tail.setAttribute('data-monoree-wallet-suffix', '');
        if (prefix.hasAttribute('aria-hidden')) tail.setAttribute('aria-hidden', prefix.getAttribute('aria-hidden'));
        tail.textContent = walletParts[1];
        content.appendChild(tail);
      } else if (suffix && suffix.firstChild.data !== walletParts[1]) {
        suffix.firstChild.data = walletParts[1];
      }
      const label = walletParts[0] + (apple ? 'Apple Pay' : 'Google Pay') + walletParts[1];
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
    } catch (_) {}
  }
  function apply(root) {
    localizeReviewUI(root);
    if (paymentLabel) {
      root.querySelectorAll('a.shopify-payment-button__more-options').forEach((node) => {
        text(node, paymentLabel);
      });
    }
    if (hasWalletLabel && root.matches('.shopify-payment-button')) {
      root.querySelectorAll('shopify-apple-pay-button[call-to-action], shopify-google-pay-button[call-to-action]').forEach(localizeWallet);
    }
    root.querySelectorAll('.restock-alerts-form-title, .restock-alerts-channels-label').forEach((node) => text(node, labels.notifyTitle));
    root.querySelectorAll('.restock-alerts-email-label-span, .restock-alerts-email-label, .restock-alerts-email-form-field-section > .restock-alerts-label').forEach((node) => text(node, labels.email));
    root.querySelectorAll('.restock-alerts-submit-button').forEach((node) => text(node, labels.notify));
    root.querySelectorAll('.restock-alerts-variant-select option, .restock-alerts-select option').forEach((option) => {
      // An explicit value is essential: otherwise changing text also changes value.
      if (!option.hasAttribute('value')) return;
      // HTML's label is the native displayed option label. Keep the app's text
      // nodes untouched as well as its value and selected state.
      const current = option.textContent.trim();
      if (/^\d+(?:[.,]\d+)?(?:\s*(?:cm|mm|ct))?$/.test(current)) {
        const next = decimal(current);
        if (option.getAttribute('label') !== next) option.setAttribute('label', next);
      }
    });

    root.querySelectorAll('.jm-review-widget-minimal-header__title, .jdgm-rev-widg__title, .jdgm-carousel-title').forEach((node) => text(node, labels.reviews));
    root.querySelectorAll('.jm-other-languages-section__heading').forEach((node) => text(node, labels.other));
    root.querySelectorAll('select.jdgm-sort-dropdown option').forEach((option) => {
      const index = sortKeys.indexOf(option.value);
      if (index >= 0 && option.hasAttribute('value')) text(option, labels.sort[index]);
    });
    // Restrict numeric edits to the widget summary beside its title, not reviews.
    root.querySelectorAll('.jm-review-widget-minimal-header__title').forEach((title) => {
      title.parentElement.querySelectorAll('.jm-cluster > .jm-text').forEach((node) => {
        const value = node.textContent.trim();
        if (/^[0-5]\.\d{1,2}$/.test(value)) text(node, decimal(value));
        if (/^\(.*\)$/.test(value) && /atsiliep|atsauksm|arvustu|opini|recenz|review/i.test(value)) {
          const count = value.match(/\d[\d\s\u00a0]*(?:[.,]\d{3})*/)?.[0].trim();
          if (count) text(node, `(${labels.count}: ${count})`);
        }
      });
    });
  }
  function enqueue(root) {
    if (!root) return;
    queued.add(root);
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      const batch = [...queued];
      queued.clear();
      for (const node of batch) if (node.isConnected) apply(node);
    });
  }
  function discover(node) {
    if (node.nodeType !== 1) return;
    if (node.matches(rootSelector)) enqueue(node);
    node.querySelectorAll(rootSelector).forEach(enqueue);
  }
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      enqueue(target?.closest(rootSelector));
      for (const node of record.addedNodes) discover(node);
    }
  });
  observer.observe(document.documentElement, { childList: true, characterData: true, subtree: true });
  discover(document.documentElement);
})();
